import { lazyLoadComponent } from "utilities/LazyLoad.utility";
import { routes } from "utilities/routes";

import { type IModalConfiguration } from "commonComponents/btWrappers/BTModal/BTModal";
import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ITaskDetailProps } from "entity/task/detail/TaskDetail";

const Task = lazyLoadComponent(() => import("./TaskDetail"));

interface IRouteTaskProps extends ITaskDetailProps {
    modalConfig?: IModalConfiguration;
}

export const RouteTask = ({ modalConfig, ...props }: IRouteTaskProps) => (
    <RouteRelative
        path={routes.task.details}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <Task {...props} {...routeProps} modalConfig={modalConfig} />
                </BTSuspense>
            );
        }}
    />
);
